import { useEffect, useState } from 'react'
import { CustomButton } from 'modules/auth/styles'
import { Col, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, Row, UncontrolledTooltip } from 'reactstrap'
import { ModalForm, MoreButton } from 'modules/app/styles'
import { Field, Formik } from 'formik'
import * as yup from 'yup'
import { ButtonLoader } from 'utils/storageUtils'
import { ReactComponent as MenuIcon } from 'assets/images/icons/menu.svg'
import { ReactComponent as CloseIcon } from 'assets/images/icons/close.svg'
import Avatar from 'modules/auth/components/Avatar'
import { createTeam_api, updateTeam_api, createTeamUsers_api, deleteTeam_api } from 'store/apis'
import UserMultiSelect from 'modules/app/components/UserMultiSelect'
import { connect } from 'react-redux'
import { MemberTabs, TeamCard, TeamUsers } from 'modules/company/styles'
import { consoleLog, getAllTeams, handleApiError, logAmplitudeEvent } from 'utils/helpers'
import { fetchTeams_action } from 'store/actions'
import { toast } from 'react-toastify'
import { orderBy } from 'lodash'

const showUsersLimit = 3

export const TeamsSetting = (props) => {
  const { fetchTeams, teams, user } = props
  const [is_submitting, set_is_submitting] = useState(false)
  const [saved, set_saved] = useState(false)
  const [editingTeam, set_editingTeam] = useState({})
  const [activeTab, set_activeTab] = useState('all')
  const [showEditModal, set_showEditModal] = useState(false)
  const [showDeleteTeamConfirm, set_showDeleteTeamConfirm] = useState(false)
  const [teamsData, set_teamsData] = useState([])

  const switchTab = (e) => {
    e.preventDefault()
    set_activeTab(e.target.attributes['id'].value)
  }

  useEffect(() => {
    if (activeTab === 'all') {
      set_teamsData(getAllTeams(teams))
    } else if (activeTab === 'sharedTeams') {
      set_teamsData(orderBy(teams.sharedTeams, (t) => t.name, 'asc'))
    } else if (activeTab === 'myTeams') {
      set_teamsData(orderBy(teams.myTeams, (t) => t.name, 'asc'))
    } else if (activeTab === 'otherTeams') {
      set_teamsData(orderBy(teams.nonParticipatingTeams, (t) => t.name, 'asc'))
    }
  }, [activeTab, teams])

  // Invite/Edit Modal
  const onShowEdit = (e, team) => {
    e.preventDefault()
    set_editingTeam(team)
    set_showEditModal(true)
  }
  const hideEditModal = () => {
    set_editingTeam({})
    set_is_submitting(false)
    set_showEditModal(false)
    set_showDeleteTeamConfirm(false)
  }
  // Delete
  const onDeleteTeam = async () => {
    try {
      set_is_submitting(true)
      await deleteTeam_api(editingTeam.id)
      toast.success('User group removed.')
      fetchTeams()
      hideEditModal()
    } catch (error) {
      consoleLog(error)
    }
    set_is_submitting(false)
  }

  console.log(is_submitting , saved);
  return (
    <>
      <ModalBody>
        <ModalForm tag='div'>
          <div className='title d-flex'>
            User Groups
            <CustomButton className='black btn-sm ml-auto my-auto px-4' onClick={(e) => onShowEdit(e, {})}>
              New User Group
            </CustomButton>
          </div>
          <br />
          <MemberTabs>
            <a href='/' onClick={switchTab} id='all' className={`${activeTab === 'all' ? 'active' : ''}`}>
              All
            </a>
            <a href='/' onClick={switchTab} id='sharedTeams' className={`${activeTab === 'sharedTeams' ? 'active' : ''}`}>
              Groups You're In
            </a>
            <a href='/' onClick={switchTab} id='myTeams' className={`${activeTab === 'myTeams' ? 'active' : ''}`}>
              Groups You Created
            </a>
            {user.membership.user_type === 'admin' && (
              <a href='/' onClick={switchTab} id='otherTeams' className={`${activeTab === 'otherTeams' ? 'active' : ''}`}>
                Other Groups
              </a>
            )}
          </MemberTabs>

          {/* List */}
          <Row>
            {teamsData.length === 0 && <span>No groups for you.</span>}
            {teamsData.map((team, i) => (
              <Col className='col-12 col-md-6 col-xxl-4 mb-4' key={i}>
                <TeamCard>
                  <div className='cardheader'>
                    <div className='name'>
                      {team.name}
                      <br />
                      <small> {team.teamusers.length} members </small>
                    </div>
                    {(team.owner_id === user.id || user.membership.user_type === 'admin') && (
                      <MoreButton direction='left' className='more-button-dropdown'>
                        <DropdownToggle caret={false} tag='div'>
                          <CustomButton type='button' className='gray toggle border shadow-none p-1'>
                            <MenuIcon style={{ width: 18, height: 18 }} />
                          </CustomButton>
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem className='py-2 border-bottom' onClick={(e) => onShowEdit(e, team)}>
                            Edit Group
                          </DropdownItem>
                          <DropdownItem
                            className='py-2 text-danger'
                            onClick={() => {
                              set_editingTeam(team)
                              set_showDeleteTeamConfirm(true)
                            }}>
                            Delete Team
                          </DropdownItem>
                        </DropdownMenu>
                      </MoreButton>
                    )}
                  </div>
                  <TeamUsers>
                    {team.teamusers
                      .filter((u, i) => i < showUsersLimit)
                      .map((teamuser, i) => (
                        <div className='avatar' id={`user_${teamuser.user.id}`} key={i}>
                          <Avatar user={teamuser.user} size={40} />
                          <UncontrolledTooltip target={`user_${teamuser.user.id}`}>
                            {teamuser.user.name}
                            {teamuser.user.id === user.id && <span>&nbsp;(me)</span>}
                          </UncontrolledTooltip>
                        </div>
                      ))}
                    {team.teamusers.length > showUsersLimit && (
                      <div className='avatar'>
                        <Avatar color='light-blue-100' user={{}} size={40}>
                          <span className='text-dark font-weight-600'> +{team.teamusers.length - showUsersLimit} </span>
                        </Avatar>
                      </div>
                    )}
                  </TeamUsers>
                </TeamCard>
              </Col>
            ))}
          </Row>
        </ModalForm>

        {showDeleteTeamConfirm && (
          <Modal zIndex={props.fullScreenStatus ? '3000000000' : '1051'} isOpen centered fade={false} toggle={() => hideEditModal()}>
            <ModalBody className='pt-5 pb-4'>
              <div className='text-center text-danger'>
                <strong>Are you sure you want to delete this group?</strong>
              </div>
              <div className='mt-4 d-flex justify-content-center align-items-center'>
                <CustomButton onClick={() => onDeleteTeam()} className='btn-sm black mx-3'>
                  Yes, Delete
                  {is_submitting && <ButtonLoader />}
                </CustomButton>
                <a
                  href='/'
                  className='mx-3 text-dark'
                  onClick={(e) => {
                    e.preventDefault()
                    hideEditModal()
                  }}>
                  Cancel
                </a>
              </div>
            </ModalBody>
          </Modal>
        )}
      </ModalBody>

      {showEditModal && (
        <Modal zIndex={props.fullScreenStatus ? '3000000000' : '1051'} isOpen centered fade={false} toggle={hideEditModal}>
          <Formik
            enableReinitialize
            validateOnBlur
            initialValues={{
              uuid: editingTeam.uuid || null,
              name: editingTeam.name || '',
              members: editingTeam.teamusers
                ? editingTeam.teamusers.map((u) => ({ ...u.user, value: u.member_code, user_id: u.user_id, option_type: 'user' }))
                : [{ ...user, value: user.member_code, user_id: user.id, option_type: 'user' }]
            }}
            validationSchema={yup.object().shape({
              name: yup.string().required(),
              members: yup.array().min(2, 'You need at least a minimum of 2 members to create a group.')
            })}
            onSubmit={async (values) => {
              try {
                set_is_submitting(true)
                const data = { name: values.name }
                let team_uuid = values.uuid
                if (team_uuid) {
                  await updateTeam_api(data, values.uuid)
                } else {
                  let team = await createTeam_api(data)
                  team_uuid = team.uuid
                  logAmplitudeEvent(`Created a new user group`)
                }
                // Update members
                const member_codes = values.members.map((value) => value.value)
                const teamusers_data = {
                  team_uuid,
                  member_codes: member_codes.join(',')
                }
                await createTeamUsers_api(teamusers_data)

                fetchTeams()
                set_saved(true)
                setTimeout(() => {
                  set_saved(false)
                  hideEditModal()
                }, 1000)
              } catch (error) {
                handleApiError(error)
              }
              set_is_submitting(false)
            }}>
            {(formikProps) => (
              <ModalForm onSubmit={formikProps.handleSubmit} autoComplete='off'>
                <ModalBody>
                  <a
                    href='/'
                    className='modal-close'
                    onClick={(e) => {
                      e.preventDefault()
                      hideEditModal()
                    }}>
                    <CloseIcon />
                  </a>
                  <div className='title'> {editingTeam?.uuid ? 'Edit' : 'Create'} User Group </div>
                  <Field name='name'>
                    {({ field }) => (
                      <FormGroup>
                        <Label>Title</Label>
                        <Input {...field} className={formikProps.errors.name ? 'error' : ''} />
                      </FormGroup>
                    )}
                  </Field>
                  <FormGroup>
                    <Label>Group Members: </Label>
                    <UserMultiSelect
                      className={formikProps.errors.members ? 'error' : ''}
                      defaultValue={formikProps.values.members}
                      options={[]}
                      onChange={(value) => formikProps.setFieldValue('members', value)}
                      user={user}
                      isCreatorRemovable
                    />
                    {formikProps.errors.members && <p className='text-danger'>{formikProps.errors.members}</p>}
                  </FormGroup>
                </ModalBody>
                <ModalFooter className='d-flex justify-content-center'>
                  {editingTeam.id && (
                    <CustomButton type='submit' className={`mx-5 ${!saved ? 'black' : 'green'}`} disabled={is_submitting || saved || !formikProps.isValid}>
                      {saved ? 'Updated' : 'Update'} {is_submitting && <ButtonLoader />}
                    </CustomButton>
                  )}
                  {!editingTeam.id && (
                    <CustomButton type='submit' className={`mx-5 ${!saved ? 'black' : 'green'}`} disabled={is_submitting || saved || !formikProps.isValid}>
                      {saved ? 'Created' : 'Create'} {is_submitting && <ButtonLoader />}
                    </CustomButton>
                  )}
                  <a
                    href='/'
                    className='text-dark font-weight-600'
                    onClick={(e) => {
                      e.preventDefault()
                      hideEditModal()
                    }}>
                    Cancel
                  </a>
                </ModalFooter>
              </ModalForm>
            )}
          </Formik>
        </Modal>
      )}
    </>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  teams: state.teams,
  fullScreenStatus: state.contents.isFullScreen
})

const mapDispatchToProps = (dispatch) => ({
  fetchTeams: () => dispatch(fetchTeams_action())
})

export default connect(mapStateToProps, mapDispatchToProps)(TeamsSetting)
